/* Wyniki Keno (Fala 8, 26.09.2026): tylko ulepszenie tabeli z SSR.
 *  1. Wiersze szczegolow (20 kul + suma, parzyste, niskie) bez JS sa widoczne.
 *     Z JS zwijamy je, zostawiamy rozwiniety pierwszy wiersz i odslaniamy
 *     przyciski „Liczby" z aria-expanded/aria-controls (Enter/Spacja dziala
 *     natywnie na <button>).
 *  2. Formularz filtra: puste pola i wartosci domyslne nie trafiaja do adresu
 *     (czysty adres = wersja indeksowana). Filtrowanie, sortowanie
 *     i stronicowanie robi serwer — tu nic nie liczymy i nic nie wysylamy. */
(function (doc) {
    'use strict';
    var box = doc.querySelector('[data-keno-tabela-sekcja]');
    if (!box || box.getAttribute('data-keno-js') === '1') { return; }
    box.setAttribute('data-keno-js', '1');

    var przyciski = box.querySelectorAll('[data-keno-rozwin]');
    Array.prototype.forEach.call(przyciski, function (btn, i) {
        var cel = doc.getElementById(btn.getAttribute('aria-controls'));
        if (!cel) { return; }
        var otwarty = i === 0;
        cel.hidden = !otwarty;
        btn.setAttribute('aria-expanded', otwarty ? 'true' : 'false');
        btn.hidden = false;
        var napis = btn.parentNode.querySelector('[data-keno-liczby-ponizej]');
        if (napis) { napis.hidden = true; }
        btn.addEventListener('click', function () {
            var teraz = btn.getAttribute('aria-expanded') !== 'true';
            btn.setAttribute('aria-expanded', teraz ? 'true' : 'false');
            cel.hidden = !teraz;
        });
    });

    var form = box.querySelector('[data-keno-filtr]');
    if (form) {
        var wszystkie = box.querySelector('[data-keno-wszystkie]');
        if (wszystkie) {
            wszystkie.addEventListener('click', function () {
                form.elements.dzien.value = '';
                form.elements.nr.value = '';
                form.elements.sort.value = 'najnowsze';
                form.elements.na.value = 'all';
                form.requestSubmit();
            });
        }
        // Jedna wartość GET dla trzech kontrolek; wykresy dostają dokładnie
        // wiersze tej samej strony SSR, wraz z filtrem dnia/numeru i kolejnością.
        doc.querySelectorAll('[data-keno-zakres-sync]').forEach(function (select) {
            select.addEventListener('change', function () {
                form.elements.na.value = select.value;
                doc.querySelectorAll('[data-keno-zakres-sync]').forEach(function (other) { other.value = select.value; });
                form.requestSubmit();
            });
        });
        form.addEventListener('submit', function () {
            var domyslne = { dzien: '', nr: '', sort: 'najnowsze', na: '25' };
            Object.keys(domyslne).forEach(function (k) {
                var pole = form.elements[k];
                if (pole && String(pole.value).trim() === domyslne[k]) { pole.disabled = true; }
            });
            // Po powrocie z historii (bfcache) pola musza byc znow aktywne.
            setTimeout(function () {
                Object.keys(domyslne).forEach(function (k) { if (form.elements[k]) { form.elements[k].disabled = false; } });
            }, 0);
        });
    }
}(document));
